import { BehaviorSubject } from 'rxjs';

export interface UpdateReference {
  hasUpdate: boolean;
  knownSinceTimeMS: number;
}

export class ApplicationUpdateService {
  private indexHTMLEtagSubject = new BehaviorSubject<string>(null);
  private initRCJSEtagSubject = new BehaviorSubject<string>(null);

  private applicationUpdateSubject = new BehaviorSubject<UpdateReference>(null);

  constructor() {
    this.init();
  }

  get applicationUpdateSubject$() {
    return this.applicationUpdateSubject;
  }

  private async init() {
    const isUpdated = await this.checkForUpdate();

    if (isUpdated) {
      return;
    }

    const intervalRef = setInterval(async () => {
      if (await this.checkForUpdate()) {
        clearInterval(intervalRef);
      }
    }, 60000);
  }

  private async checkForUpdate(): Promise<boolean> {
    const [isInitRCJSUpdated, isIndexHTMLUpdated] = await Promise.all([
      this.isFileUpdated('/initrc.js', this.initRCJSEtagSubject),
      this.isFileUpdated('/', this.indexHTMLEtagSubject),
    ]);

    const isUpdated = isInitRCJSUpdated || isIndexHTMLUpdated;

    if (isUpdated) {
      this.applicationUpdateSubject.next({
        hasUpdate: true,
        knownSinceTimeMS: Date.now(),
      });
      this.applicationUpdateSubject.complete();
    }

    return isUpdated;
  }

  private async isFileUpdated(
    path: string,
    etagSubject: BehaviorSubject<string>,
  ): Promise<boolean> {
    const response = await fetch(path, {
      method: 'HEAD',
      cache: 'no-cache',
    });

    const etag = response.headers.get('etag');
    const currentEtag = etagSubject.value;

    if (currentEtag === null) {
      // first known value
      etagSubject.next(etag);
      return false;
    }

    return currentEtag !== etag;
  }
}
